<template>
  <div class="cont">
    <!-- 聊天框 -->
    <div class="liaotian_cont" id="data-list-content" ref="xinxikuang">
      <template v-for="(item, inde) in xinxishuju">
        <template v-if="item.state == 1">
          <div class="kefu_linshi_cont" :key="inde" v-if="code.includes('JQ') || code.includes('Hz')">
            <p class="kefu_tit">
              <span>{{ item.mem }}</span>
            </p>
            <img
              :src="stripTags(item.txt)"
              v-if="stripTags(item.txt).includes('.jpg') || stripTags(item.txt).includes('.png') || stripTags(item.txt).includes('.jpeg')"
              @click="showImg($event)"
            />
            <div class="kefu_nr" style="background-color: #ffecd0" v-else>
              <p v-html="stripTags(item.txt)"></p>
            </div>
          </div>
          <div :key="inde" style="text-align: right" v-else>
            <div class="my_tit">
              <!-- 接手客服 -->
              <p>{{ item.mem }} {{ item.data }}</p>
            </div>
            <img
              :src="stripTags(item.txt)"
              v-if="stripTags(item.txt).includes('.jpg') || stripTags(item.txt).includes('.png') || stripTags(item.txt).includes('.jpeg')"
              @click="showImg($event)"
            />
            <div class="kefu_fayan" style="text-align: right" v-else>
              <p v-html="stripTags(item.txt)"></p>
            </div>
          </div>
        </template>
        <template v-else-if="item.state == 2">
          <div :key="inde">
            <p class="xitong_tit">
              <span>{{ laiyuan === '5173' ? '5173买家' : '买家：' + item.mem }}</span>
              <span>{{ item.data }}</span>
            </p>
            <img
              :src="stripTags(item.txt)"
              v-if="stripTags(item.txt).includes('.jpg') || stripTags(item.txt).includes('.png') || stripTags(item.txt).includes('.jpeg')"
              @click="showImg($event)"
            />
            <div class="my_fayan" v-else>
              <p v-html="stripTags(item.txt)"></p>
            </div>
          </div>
        </template>
        <template v-else-if="item.state == 4">
          <div :key="inde">
            <p class="xitong_tit">
              <span>{{ laiyuan === '5173' ? '5173卖家' : '卖家：' + item.mem }}</span>
              <span>{{ item.data }}</span>
            </p>
            <img
              :src="stripTags(item.txt)"
              v-if="stripTags(item.txt).includes('.jpg') || stripTags(item.txt).includes('.png') || stripTags(item.txt).includes('.jpeg')"
              @click="showImg($event)"
            />
            <div class="xitong_fayan" v-else>
              <p v-html="stripTags(item.txt)"></p>
            </div>
          </div>
        </template>
        <template v-else>
          <div :key="inde">
            <p class="xitong_tit">
              <span>{{ item.mem }}</span>
              <span>{{ item.data }}</span>
            </p>
            <img
              :src="stripTags(item.txt)"
              v-if="stripTags(item.txt).includes('.jpg') || stripTags(item.txt).includes('.png') || stripTags(item.txt).includes('.jpeg')"
              @click="showImg($event)"
            />
            <div class="my_fayan" v-else>
              <p v-html="stripTags(item.txt)"></p>
            </div>
          </div>
        </template>
      </template>
    </div>
    <!-- 功能按钮 -->
    <div class="gongnenganniu">
      <i class="iconfont icon-a-tupian" @click="chooseImage"></i>
      <input @change="photoChange($event)" type="file" id="upload_file" multiple style="display: none" />
      <template v-if="!code.includes('JQ') && !code.includes('Hz')">
        <div :class="jsonhouzui == 'd' ? 'lianxi_btn act' : 'lianxi_btn'" @click="huihuaqiehuan('d')" v-if="laiyuan !== '5173'">
          <i class="iconfont icon-kefu1"></i>
          <p>联系卖家</p>
          <span v-if="weidudkefu * 1 > 0">{{ weidudkefu }}</span>
        </div>
        <div :class="jsonhouzui == 'c' ? 'lianxi_btn act' : 'lianxi_btn'" @click="huihuaqiehuan('c')" v-if="laiyuan !== '5173'">
          <i class="iconfont icon-kefu1"></i>
          <p>联系买家</p>
          <span v-if="weiduckefu * 1 > 0">{{ weiduckefu }}</span>
        </div>
      </template>
    </div>
    <!-- 输入栏 -->
    <div class="shurulan">
      <textarea class="maijiafasong" v-model="fasongxinxi" v-if="laiyuan === '5173'" @keyup.enter.exact="Write5('txt')" @keyup.ctrl.enter="linefeed"></textarea>
      <template v-else>
        <textarea class="maijiafasong" v-model="fasongxinxi" v-if="jsonhouzui == 'c'" @keyup.enter.exact="Write3('txt')" @keyup.ctrl.enter="linefeed"></textarea>
        <textarea class="maijiafasong" v-model="fasongxinxi" v-if="jsonhouzui == 'd'" @keyup.enter.exact="Write4('txt')" @keyup.ctrl.enter="linefeed"></textarea>
        <textarea class="maijiafasong" v-model="fasongxinxi" v-if="jsonhouzui == 'f'" @keyup.enter.exact="Write5('txt')" @keyup.ctrl.enter="linefeed"></textarea>
      </template>
      <div>
        <p>Enter发送</p>
        <a href="javascript:;" @click="Write5('txt')" v-if="laiyuan === '5173'">发送</a>
        <template v-else>
          <a href="javascript:;" @click="Write3('txt')" v-if="jsonhouzui == 'c'">发送</a>
          <a href="javascript:;" @click="Write4('txt')" v-if="jsonhouzui == 'd'">发送</a>
          <a href="javascript:;" @click="Write5('txt')" v-if="jsonhouzui == 'f'">发送</a>
        </template>
      </div>
    </div>
    <!-- 图片放大 -->
    <div v-if="showimg" class="fangda_cont" @click="closeimg">
      <div class="mengc"></div>
      <img :src="fangdaimg" class="fangdatu" v-if="showimg" ref="imgchicun" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DingDan',
  components: {},
  props: ['code', 'laiyuan'],
  data() {
    return {
      timer1: null,
      timer2: null,
      xinxishuju: [],
      fasongxinxi: '',
      jsonhouzui: 'c',
      weiduc: 0, // 买家未读信息数
      weidud: 0, // 卖家未读信息数
      weiduckefu: 0, // 买家与客服未读信息数
      weidudkefu: 0, // 卖家与客服未读信息数
      fasongimng: '',
      fangdaimg: '',
      showimg: false,
      ch: 0,
      badwordsList: [],

      ws: null, // WebSocket 对象
      selectedRole: '客服', // 默认角色
      isConnected: false // 连接状态
    }
  },
  watch: {
    code() {
      this.xinxishuju = []
      // 判断聊天信息定时器的执行
      if (this.timer1 !== null) {
        clearInterval(this.timer1)
        this.timer1 = null
      }

      if (this.laiyuan === '5173') {
        this.jsonhouzui = 'f'
        this.timer1 = setInterval(() => {
          this.zixunxinxi()
        }, 1000)
        this.disconnectWebSocket()
        this.connectWebSocket()
      } else if (this.code.includes('JQ')) {
        this.jsonhouzui = 'f'
        this.timer1 = setInterval(() => {
          this.zixunxinxi()
        }, 1000)
        this.disconnectWebSocket()
        this.connectWebSocket()
      } else if (this.code.includes('Hz')) {
        this.jsonhouzui = 'f'
        this.timer1 = setInterval(() => {
          this.zixunxinxi()
        }, 1000)
        this.disconnectWebSocket()
        this.connectWebSocket()
      } else {
        this.jsonhouzui = 'c'
        this.timer1 = setInterval(() => {
          this.zixunxinxi()
        }, 1000)
        this.disconnectWebSocket()
        this.connectWebSocket()
      }

      // 判断未读信息数定时器的执行
      if (this.timer2 !== null) {
        clearInterval(this.timer2)
      }
      this.timer2 = setInterval(() => {
        try {
          this.weidu()
        } catch (error) {
          console.error('定时器执行 weidu 方法时发生错误:', error)
        }
      }, 1000)
      this.NewAdd()
    },
    xinxishuju(a, b) {
      // console.log(a)
      // console.log(b)
      const len1 = a.length
      const len2 = b.length
      if (len2 === 0) {
        this.$nextTick(() => {
          this.$refs.xinxikuang.scrollTop = this.$refs.xinxikuang.scrollHeight
        })
        return
      }
      if (this.$refs.xinxikuang.scrollHeight - this.$refs.xinxikuang.scrollTop === this.ch) {
        this.$nextTick(() => {
          this.$refs.xinxikuang.scrollTop = this.$refs.xinxikuang.scrollHeight
        })
        return
      }
      if (len1 === len2) return
      // if (a[len1 - 1].state === 2 || a[len1 - 1].state === 4) return
      this.$nextTick(() => {
        this.$refs.xinxikuang.scrollTop = this.$refs.xinxikuang.scrollHeight
      })
    },
    fangdaimg() {
      this.$nextTick(() => {
        if (this.fangdaimg === '') {
          this.showimg = false
        } else {
          this.showimg = true
        }

        // this.$refs.imgchicun
      })
    }
  },
  created() {
    this.getjson()
    if (this.laiyuan === '5173') {
      this.jsonhouzui = 'f'
    }
  },
  mounted() {
    this.ch = this.$refs.xinxikuang.scrollHeight
  },
  computed: {},
  methods: {
    async getjson() {
      const { data: res } = await this.$axios.get('https://img.yx915.com/TxtDate/keyss.txt')
      this.badwordsList = res.replaceAll('\n', '').replaceAll('\r', '').split(',')
    },
    handleInput(zhi) {
      let filtered = zhi
      if (this.badwordsList) {
        for (const word of this.badwordsList) {
          const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
          const reg = new RegExp(escapedWord, 'gi')
          filtered = filtered.replace(reg, '*'.repeat(word.length))
        }
      }
      return filtered
    },
    stripTags(html) {
      // 提取图片地址
      const imgRegex = /<img[^>]+src="([^">]+)"/g
      const match = imgRegex.exec(html)
      if (match) {
        return match[1]
      }
      const doc = new DOMParser().parseFromString(html, 'text/html')
      if (html.includes('.jpg') || html.includes('.png') || html.includes('.jpeg')) return html
      return doc.body.textContent.replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" style="color: blue; text-decoration: underline;">$1</a>') || ''
    },
    // 会话切换
    huihuaqiehuan(e) {
      if (this.code === undefined) return alert('请选择会话')
      this.jsonhouzui = e
      this.xinxishuju = []
      this.disconnectWebSocket()
      this.zixunxinxi()
      this.connectWebSocket()
      this.Write8()
    },
    // 获取临时咨询信息
    async zixunxinxi() {
      const url = 'https://img.yx915.com/json/' + this.code + '/' + this.code + '' + this.jsonhouzui + '.json'
      const { data: res } = await this.$axios({
        method: 'get',
        url: url,
        params: {
          v: Math.random()
        },
        dataType: 'text'
      })
      // console.log(res)
      if (Array.isArray(res)) this.xinxishuju = res
      if (this.ws === null) this.connectWebSocket()
    },
    // 买家和客服之间的聊天
    async Write3(sta) {
      if (sta === 'txt') {
        if (this.fasongxinxi === '') {
          alert('请输入信息')
          this.fasongxinxi = ''
          return
        }
      }
      const shijianc = new Date().getTime()
      const obj = {
        dd: this.code,
        txt: this.fasongxinxi,
        mem: localStorage.name,
        state: '1'
      }
      if (sta === 'img') {
        obj.txt = this.fasongimng
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: 'https://api.longxiagame.com/Chatsystem/Write3.aspx',
        // params:{},  // get请求参数
        data: JSON.stringify(obj), // post请求参数
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-service-app': 'chenshi001',
          'x-service-token': this.$md5('chenshi001' + 'd832912d76d935cab49c76462312c848' + shijianc).toUpperCase(),
          'x-service-timestamp': shijianc
        }
      })
      // console.log(res)
      if (res[0].msg === '成功') {
        this.sendMessage(sta, obj.txt)
        this.zixunxinxi()
        this.Write8()
      }
    },
    // 信息换行
    linefeed() {
      this.fasongxinxi += '\n'
    },
    // 卖家和客服之间的聊天
    async Write4(sta) {
      if (sta === 'txt') {
        if (this.fasongxinxi === '') {
          alert('请输入信息')
          this.fasongxinxi = ''
          return
        }
      }
      const shijianc = new Date().getTime()
      const obj = {
        dd: this.code,
        txt: this.fasongxinxi,
        mem: localStorage.name,
        state: '1'
      }
      if (sta === 'img') {
        obj.txt = this.fasongimng
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: 'https://api.longxiagame.com/Chatsystem/Write4.aspx',
        // params:{},  // get请求参数
        data: JSON.stringify(obj), // post请求参数
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-service-app': 'chenshi001',
          'x-service-token': this.$md5('chenshi001' + 'd832912d76d935cab49c76462312c848' + shijianc).toUpperCase(),
          'x-service-timestamp': shijianc
        }
      })
      // console.log(res)
      if (res[0].msg === '成功') {
        this.sendMessage(sta, obj.txt)
        this.zixunxinxi()
        this.Write8()
      }
    },
    // 买卖家和客服之间的聊天
    async Write5(sta) {
      if (sta === 'txt') {
        if (this.fasongxinxi === '') {
          alert('请输入信息')
          this.fasongxinxi = ''
          return
        }
      }
      const shijianc = new Date().getTime()
      const obj = {
        dd: this.code,
        txt: this.fasongxinxi,
        mem: localStorage.name,
        state: '1'
      }
      if (sta === 'img') {
        obj.txt = this.fasongimng
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: 'https://api.longxiagame.com/Chatsystem/Write5.aspx',
        // params:{},  // get请求参数
        data: JSON.stringify(obj), // post请求参数
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-service-app': 'chenshi001',
          'x-service-token': this.$md5('chenshi001' + 'd832912d76d935cab49c76462312c848' + shijianc).toUpperCase(),
          'x-service-timestamp': shijianc
        }
      })
      // console.log(res)
      if (res[0].msg === '成功') {
        this.sendMessage(sta, obj.txt)
        this.zixunxinxi()
        this.Write8()
      }
    },
    // 获取未读信息数
    async weidu() {
      const url = 'https://img.yx915.com/json/' + this.code + '/' + this.code + 'y.json'
      const { data: res } = await this.$axios({
        method: 'get',
        url: url,
        params: {
          v: Math.random()
        },
        dataType: 'text'
      })
      this.weiduc = res[0] === null ? 0 : res[0] * 1
      this.weidud = res[1] === null ? 0 : res[1] * 1
      this.weiduckefu = res[2] === null ? 0 : res[2] * 1
      this.weidudkefu = res[3] === null ? 0 : res[3] * 1
    },

    // 清除未读数
    async Write8() {
      const shijianc = new Date().getTime()
      // eslint-disable-next-line camelcase
      const txt_nr = new Array(4)
      if (this.jsonhouzui === 'd') {
        // 卖家
        txt_nr[0] = this.weiduc
        txt_nr[1] = this.weidud * 1 + 1
        txt_nr[2] = this.weiduckefu
        txt_nr[3] = 0
      } else if (this.jsonhouzui === 'c') {
        // 买家
        txt_nr[0] = this.weiduc * 1 + 1
        txt_nr[1] = this.weidud
        txt_nr[2] = 0
        txt_nr[3] = this.weidudkefu
      } else if (this.jsonhouzui === 'f') {
        // 买家
        txt_nr[0] = this.weiduc * 1 + 1
        txt_nr[1] = this.weidud * 1 + 1
        txt_nr[2] = 0
        txt_nr[3] = 0
      }
      // 买家
      const obj = {
        dd: this.code,
        txt: txt_nr
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: 'https://api.longxiagame.com/Chatsystem/Write8.aspx',
        data: JSON.stringify(obj), // post请求参数
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-service-app': 'chenshi001',
          'x-service-token': this.$md5('chenshi001' + 'd832912d76d935cab49c76462312c848' + shijianc),
          'x-service-timestamp': shijianc
        }
      })
      console.log(res)
    },
    // 生成聊天文件
    async NewAdd() {
      const shijianc = new Date().getTime() // 获取时间戳
      const obj = {
        dd: this.code
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: 'https://api.longxiagame.com/Chatsystem/NewAdd.aspx',
        data: JSON.stringify(obj), // post请求参数
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-service-app': 'chenshi001',
          'x-service-token': this.$md5('chenshi001' + 'd832912d76d935cab49c76462312c848' + shijianc),
          'x-service-timestamp': shijianc
        }
      })
      console.log(res)
    },
    // 上传图片 start
    chooseImage() {
      document.getElementById('upload_file').click() // 触发input-file文件上传控件 事件photoChange
    },
    photoChange(el) {
      const file = el.target.files // name: "dangqi1.png" || type: "image/png"
      for (let i = 0; i < file.length; i++) {
        const type = file[i].type.split('/')[0]
        if (type === 'image') {
          // 将图片img转化为base64
          const reader = new FileReader()
          reader.readAsDataURL(file[i])
          const that = this
          reader.onloadend = function () {
            const dataURL = reader.result
            const blob = that.dataURItoBlob(dataURL)
            that.upload(blob) // 执行上传接口
          }
        } else {
          alert('上传了非图片')
        }
      }
    },
    dataURItoBlob(dataURI) {
      // base64 解码
      const byteString = window.atob(dataURI.split(',')[1])
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      // const T = mimeString.split('/')[1]
      const ab = new ArrayBuffer(byteString.length)
      const ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    async upload(imgUrl) {
      const shijianc = new Date().getTime()
      const formdata = new FormData()
      formdata.append('file', imgUrl) // 下面是要传递的参数

      const { data: res } = await this.$axios.post('https://api.longxiagame.com/Imgupdate/Url_Img_Zx.aspx', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-service-app': 'chenshi001',
          'x-service-token': this.$md5('chenshi001' + 'd832912d76d935cab49c76462312c848' + shijianc).toUpperCase(),
          'x-service-timestamp': shijianc
        }
      })
      // console.log(res)
      this.fasongimng = res.data.src

      if (this.laiyuan === '5173') {
        this.Write5('img')
      } else if (this.jsonhouzui === 'f') {
        this.Write5('img')
      } else if (this.jsonhouzui === 'c') {
        this.Write3('img')
      } else if (this.jsonhouzui === 'd') {
        this.Write4('img')
      }
    }, // 上传图片 end
    // 放大图片
    showImg(e) {
      if (e.target.src) {
        this.fangdaimg = e.target.src
      }
    },
    closeimg() {
      this.showimg = false
      this.fangdaimg = ''
    },
    connectWebSocket() {
      const groupId = this.code
      const role = this.selectedRole
      const wenjian = this.jsonhouzui

      // 创建 WebSocket 客户端对象
      this.ws = new WebSocket('wss://chat.longxiagame.com/chat')

      // WebSocket 打开连接
      this.ws.onopen = () => {
        // alert('已连接到服务器')
        this.isConnected = true

        // 发送角色和群组信息
        const message = `${role},${groupId},${wenjian}`
        this.ws.send(message)
      }

      // 接收消息
      this.ws.onmessage = (event) => {
        // this.output += `${event.data}\n`
        if (!event.data.includes('加入群聊') && !event.data.includes('离开群聊')) {
          this.xinxishuju = JSON.parse(event.data)
          if (window.Notification && Notification.permission !== 'denied' && this.chatlist[this.chatlist.length - 1].state !== 1) {
            Notification.requestPermission(function (status) {
              const n = new Notification('叮~~', { body: '您有新消息啦，请及时处理哦！' })
              console.log(n)
            })
          }
        }
        this.scrollToBottom()
      }

      // 连接关闭
      this.ws.onclose = () => {
        alert('ws已经断开')
        this.isConnected = false
        this.ws = null
      }

      // 错误处理
      this.ws.onerror = (error) => {
        this.output += `Error: ${error.message}\n`
      }
    },
    disconnectWebSocket() {
      if (this.ws) {
        this.ws.onclose = null
        this.ws.close()
        this.isConnected = false
        this.ws = null
      }
    },
    sendMessage(sta, message) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(message)
        if (sta === 'txt' && this.fasongxinxi === message) this.fasongxinxi = ''
        if (sta === 'img') this.fasongimng = ''
        this.scrollToBottom()
      } else {
        alert('请确保已连接到服务器！')
      }
    },
    scrollToBottom() {
      // 自动滚动到底部
      this.$nextTick(() => {
        setTimeout(() => {
          const scrollel = this.$refs.scrollRef
          if (scrollel) scrollel.scrollTo({ top: scrollel.scrollHeight, behavior: 'smooth' })
        }, 500)
      })
    }
  },
  filters: {
    htnlguolv(str) {
      return str.replace(/<\/?.+?>/g, '').replace(/ /g, '')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer1)
    clearInterval(this.timer2)
    this.timer1 = null
    this.timer2 = null
    // 组件销毁前关闭 WebSocket
    this.disconnectWebSocket()
  },
  destroyed() {
    clearInterval(this.timer1)
    clearInterval(this.timer2)
    this.timer1 = null
    this.timer2 = null
  }
}
</script>
<style lang="less" scoped>
.cont {
  width: 1050px;
  text-align: left;
  background-color: #f5f5f5;
  display: inline-block;
  vertical-align: top;
  .liaotian_cont {
    width: 1050px;
    height: calc(100vh - 284px);
    border: 1px solid #e5e5e5;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: auto;
    padding-bottom: 10px;
    &::after {
      content: '';
      height: 1px;
      width: 1050px;
      background-color: #e5e5e5;
      position: absolute;
      left: 0;
      top: 0;
    }
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 60px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: #999;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      background: #ededed;
    }
    img {
      max-width: 230px;
      margin-top: 5px;
      border-radius: 6px;
    }
    .xitong_tit {
      margin-top: 15px;
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
      }
      span:nth-child(1) {
        color: rgb(255, 91, 1);
      }
      span:nth-child(2) {
        margin-left: 8px;
        color: rgb(153, 153, 153);
      }
    }
    .xitong_fayan {
      margin-top: 10px;
      text-align: left;
      line-height: 1.6;
      padding: 6px;
      box-sizing: border-box;
      color: rgb(77, 77, 77);
      font-size: 12px;
      display: inline-block;
      background-color: #9eea65;
      border-radius: 3px;
      text-align: justify;
      max-width: 70%;
      p {
        font-size: 12px;
      }
      ::v-deep .getRecord {
        img {
          width: 166px !important;
        }
      }
    }
    .kefu_tit {
      margin-top: 15px;
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
      }
      span:nth-child(1) {
        color: rgb(0, 0, 0);
      }
      span:nth-child(2) {
        margin-left: 8px;
        color: rgb(153, 153, 153);
      }
    }
    ::v-deep .kefu_fayan {
      font-size: 12px;
      margin-top: 10px;
      border-radius: 3px;
      background-color: #d0e9ff;
      color: rgb(77, 77, 77);
      line-height: 1.6;
      padding: 6px;
      box-sizing: border-box;
      display: inline-block;
      text-align: justify;
      max-width: 70%;
      white-space: pre-wrap;
      p {
        font-size: 12px;
      }
      .getRecord {
        img {
          width: 166px !important;
        }
      }
    }
    ::v-deep .pingjia {
      display: none;
    }
    ::v-deep .kefupingjia {
      font-size: 12px;
      color: #f00;
      margin-top: 10px;
      border-radius: 3px;
      line-height: 1.6;
      padding: 6px;
      box-sizing: border-box;
      display: inline-block;
      text-align: justify;
      max-width: 70%;
      white-space: pre-wrap;
      background-color: #fff;
    }
    .my_tit {
      margin-top: 15px;
      text-align: right;
      p {
        font-size: 12px;
        color: rgb(153, 153, 153);
      }
    }
    ::v-deep .my_fayan {
      text-align: left;
      p {
        margin-top: 10px;
        text-align: left;
        line-height: 1.6;
        padding: 6px;
        box-sizing: border-box;
        color: rgb(77, 77, 77);
        font-size: 12px;
        display: inline-block;
        background-color: #fff;
        border-radius: 3px;
        text-align: justify;
        max-width: 70%;
        word-wrap: break-word;
        white-space: pre-wrap;
        .getRecord {
          img {
            width: 166px !important;
          }
        }
      }
    }
    ::v-deep .buy_fayan {
      text-align: left;
      p {
        margin-top: 10px;
        text-align: left;
        line-height: 1.6;
        padding: 6px;
        box-sizing: border-box;
        color: rgb(77, 77, 77);
        font-size: 12px;
        display: inline-block;
        background-color: #fff;
        border-radius: 3px;
        text-align: justify;
        max-width: 70%;
        word-wrap: break-word;
        white-space: pre-wrap;
        .getRecord {
          img {
            width: 166px !important;
          }
        }
      }
    }
    ::v-deep .getRecord {
      margin-top: 5px;
      img {
        max-width: 166px;
      }
    }
  }
  .gongnenganniu {
    height: 44px;
    line-height: 44px;
    padding: 0 20px;
    border-left: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
    width: 100%;
    box-sizing: border-box;
    .lianxi_btn {
      float: right;
      position: relative;
      height: 44px;
      line-height: 44px;
      text-align: center;
      width: 110px;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
      .iconfont {
        color: #ff9f00;
        display: inline-block;
        vertical-align: middle;
      }
      p {
        font-size: 14px;
        color: #000000;
        margin-left: 5px;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        font-size: 13px;
        border-radius: 50%;
        background-color: #ff0000;
        position: absolute;
        top: 6px;
        right: 6px;
        color: #fff;
        min-width: 14px;
        height: 14px;
        line-height: 14px;
        text-align: center;
      }
    }
    .lianxi_btn.act {
      background-color: #fff;
    }
  }
  .shurulan {
    width: 100%;
    height: 135px;
    background-color: #fff;
    border-left: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
    padding: 20px;
    box-sizing: border-box;
    textarea {
      width: 100%;
      border: 0;
      font-size: 14px;
      color: #000000;
      height: 60px;
      resize: none;
      outline: none;
    }
    div {
      text-align: right;
      margin-top: 5px;
      p {
        font-size: 12px;
        color: #999999;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        vertical-align: middle;
      }
      a {
        display: inline-block;
        margin-left: 8px;
        height: 30px;
        line-height: 30px;
        width: 64px;
        color: #fff;
        font-size: 14px;
        background-color: #0081fb;
        text-align: center;
        border-radius: 5px;
        text-decoration: none;
      }
    }
  }
}
.fangda_cont {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .mengc {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  img {
    position: absolute;
    max-height: 80%;
  }
}

.kefu_linshi_cont {
  text-align: right;
  margin-top: 8px;
  .kefu_tit {
    span:nth-child(1) {
      font-size: 14px;
      color: #1a1a1a;
    }
    span:nth-child(2) {
      font-size: 12px;
      color: #a1a6af;
      margin-left: 10px;
    }
  }
  .kefu_nr {
    margin-top: 5px;
    padding: 8px 12px;
    background-color: #fff;
    line-height: 1.6;
    box-sizing: border-box;
    display: inline-block;
    max-width: 70%;
    word-wrap: break-word;
    border-radius: 6px;
    p {
      font-size: 13px;
      color: rgb(77, 77, 77);
    }
    span {
      color: #f00;
      font-weight: bold;
    }
  }
}
</style>
